// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";

import StoreProductMultipleSales, {
    StoreMultipleSalesMessageStyle,
} from "@store/Library/Components/Foundation/StoreProduct/StoreProductMultipleSales";

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StoreMinimumSalesMessage from "@store/Library/Components/Common/StoreMinimumSalesMessage";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React from "react";
import { css } from "styled-components";

interface MinimumMultipleQuantityWarningsStyles {
    wrapper?: InjectableCss;
    storeMinimumExtendedStyles?: StoreMultipleSalesMessageStyle;
    storeProductMultipleSalesExtendedStyles?: StoreMultipleSalesMessageStyle;
}
export const minimumMultipleQuantityWarningsStyles: MinimumMultipleQuantityWarningsStyles = {
    wrapper: {
        css: css`
            max-width: 20em;
            margin: 0.5rem 0;
        `,
    },
};
interface MinimumMultipleQuantityWarningsProps {
    minimumQuantity: number;
    multipleQuantity: number;
    extendedStyles?: MinimumMultipleQuantityWarningsStyles;
    overrideStyles?: MinimumMultipleQuantityWarningsStyles;
}
const MinimumMultipleQuantityWarnings: React.FC<MinimumMultipleQuantityWarningsProps> = ({
    minimumQuantity,
    multipleQuantity,
    extendedStyles,
    overrideStyles,
}) => {
    const styles = useExpandProps(minimumMultipleQuantityWarningsStyles, extendedStyles, overrideStyles);
    if (minimumQuantity < 2 && multipleQuantity < 2) {
        return null;
    }
    const showMinimumSalesMessage = minimumQuantity > 1 && multipleQuantity < 2;
    return (
        <StyledWrapper {...styles.wrapper}>
            {showMinimumSalesMessage ? (
                <StoreMinimumSalesMessage
                    extendedStyles={styles.storeMinimumExtendedStyles}
                    qty={minimumQuantity}
                    warning
                />
            ) : (
                <StoreProductMultipleSales qty={multipleQuantity} warning />
            )}
        </StyledWrapper>
    );
};

export default MinimumMultipleQuantityWarnings;
